import z from 'zod'

export const dateFilterSchema = z.discriminatedUnion('operator', [
  z.object({
    operator: z.literal('between'),
    from: z.string(),
    to: z.string(),
  }),
  z.object({
    operator: z.literal('before'),
    date: z.string(),
  }),
  z.object({
    operator: z.literal('after'),
    date: z.string(),
  }),
  z.object({
    operator: z.literal('onDay'),
    date: z.string(),
  }),
  z.object({
    operator: z.literal('onMonth'),
    year: z.number(),
    month: z.number(),
  }),
  z.object({
    operator: z.literal('onYear'),
    year: z.number(),
  }),
])

export const numberFilterSchema = z.discriminatedUnion('operator', [
  z.object({
    operator: z.literal('between'),
    from: z.number(),
    to: z.number(),
  }),
  z.object({
    operator: z.literal('greaterThan'),
    value: z.number(),
  }),
  z.object({
    operator: z.literal('lessThan'),
    value: z.number(),
  }),
  z.object({
    operator: z.literal('equal'),
    value: z.number(),
  }),
])
